import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			communityPlsrScholarsContentSectionHeaderBigCls: string;
			communityPlsrScholarsContentSectionHeaderCls: string;
			communityPlsrScholarsContentSectionSubheaderCls: string;
		}
	},

	slug: string
}

class Hero extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('Community Plsr Scholars Hero Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.communityPlsrScholarsContentSectionHeaderBigCls || '', 'community_plsr_scholars_hero', { animCls: 'animate__lightSpeedInLeft', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.communityPlsrScholarsContentSectionHeaderCls || '', 'community_plsr_scholars_hero', { animCls: 'animate__zoomIn50P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.communityPlsrScholarsContentSectionSubheaderCls || '', 'community_plsr_scholars_hero', { animCls: 'animate__fadeInRight25P', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Hero;